import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { GradeBadge } from "@/components/Badges";

export default function GradeReview() {
  const { t } = useLang();
  const [ins, setIns] = useState([]);
  const [reasons, setReasons] = useState({});
  const [newGrade, setNewGrade] = useState({});
  const load = () => api.get("/inspections").then((r) => setIns(r.data.slice(0, 50)));
  useEffect(() => { load(); }, []);

  const revise = async (id) => {
    if (!reasons[id]) return alert(t("reason") + " required");
    await api.patch(`/inspections/${id}/grade`, { grade: newGrade[id] || "B", reason: reasons[id] });
    setReasons({ ...reasons, [id]: "" });
    load();
  };

  return (
    <div>
      <div className="eyebrow">{t("nav_grade_review")}</div>
      <h1 className="text-2xl font-bold mb-4" style={{ color: "var(--brand-navy)" }}>{t("nav_grade_review")}</h1>
      <div className="space-y-2">
        {ins.map((i) => (
          <div key={i.id} data-testid={`grade-review-${i.id}`} className="hag-surface p-3">
            <div className="flex items-center gap-2 flex-wrap">
              <div className="text-sm font-semibold">{i.milestone}</div>
              <div className="text-xs text-[#7C8E9E]">{new Date(i.date).toLocaleString()}</div>
              <GradeBadge grade={i.grade} />
              {(i.grade_history || []).length > 1 && (
                <span className="status-chip pace-amber text-[10px]">Revised {(i.grade_history || []).length - 1}×</span>
              )}
            </div>
            <div className="text-xs text-[#4A627A] mt-1">
              History: {(i.grade_history || []).map((h, idx) => `${h.grade}${h.reason ? ` (${h.reason})` : ""}`).join(" → ")}
            </div>
            <div className="flex gap-2 mt-2 items-center flex-wrap">
              <select
                data-testid={`gr-select-${i.id}`}
                className="h-10 border border-[#1B3A5C]/15 rounded-md px-2 text-sm"
                value={newGrade[i.id] || i.grade}
                onChange={(e) => setNewGrade({ ...newGrade, [i.id]: e.target.value })}
              >
                <option>A</option><option>B</option><option>C</option>
              </select>
              <input
                data-testid={`gr-reason-${i.id}`}
                placeholder={t("reason")}
                value={reasons[i.id] || ""}
                onChange={(e) => setReasons({ ...reasons, [i.id]: e.target.value })}
                className="flex-1 h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm"
              />
              <button
                data-testid={`gr-btn-${i.id}`}
                onClick={() => revise(i.id)}
                className="h-10 px-3 rounded-md text-sm text-white"
                style={{ background: "var(--brand-navy)" }}
              >{t("revise_grade")}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
